import { Box, ColorOptions, IconNew as Icon, Text } from '@jfs/ui-new'
import { FC, Fragment, useState } from 'react'
import { ViewStyle } from 'react-native'
import { Checkbox, CheckBoxTypes } from '../../../../comps/Checkbox'
import { LinearGradientContainer } from '../../../../comps/LinearGradient'
import { ModBox } from '../../../../comps/ModifiedBox/ModifiedBox'
import { ToastPosition, ToastType } from '../../../../comps/Toast'
import { staticStrings } from '../../../../data/static/strings'
import { useStores } from '../../../../data/store'
import { Colors, useWindowDimensions } from '../../../../util/util'
import MIDSelector from '../MIDSelector'
import { styles1 } from '../MIDSelector/styles'
import { styles } from './styles'
import SubMenu from './SubMenu'
import { TitleComponent } from './TitleComponent'

const labelSwitchAccount = 'Switch Account'
export interface UserSettingsProps {
  onSelected: () => void
  left: number
}

const getContainerStyle = (left: number, viewPortWidth: number): ViewStyle[] => {
  return [styles(viewPortWidth).container, { left }]
}
const UserSettings: FC<UserSettingsProps> = ({ onSelected, left = 0 }: UserSettingsProps) => {
  const [expand, setExpend] = useState(false)
  
  const { merchantname, selectedMid, selectedTid, selectedMerchantStatus, sortedMerchants, setToastMessage } = useStores((store) => ({
    merchantname: store?.settings?.metaData?.selectedMercName,
    selectedMid: store?.user?.selectedMid,
    selectedTid: store?.user?.selectedTid,
    selectedMerchantStatus: store?.settings?.metaData?.selectedMerchantStatus,
    sortedMerchants: store?.user?.sortedMerchants(),
    setToastMessage: store?.response?.setCustomToast,
  }))

  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)
  const positionLeft = viewPortWidth < 660 ? 0 : left

  const handelSwitchAccount = (): void => setExpend((prev) => !prev)

  // views cant be removed , styles are overlaping cellContainer.enabled , other views have gradient bg

  const onCopy = () => {
    setToastMessage({
      message: staticStrings.copyText,
      color: 'GREEN',
      position: ToastPosition.BOTTOM,
      toastType: ToastType.POSITIVE,
    })
  }

  return (
    <LinearGradientContainer
      direction="HORIZONTAL"
      colorArray={[Colors.BASIC_WHITE, Colors.SECONDARY_WHITE]}
      customStyle={getContainerStyle(positionLeft, viewPortWidth) as ViewStyle}>
      <Fragment>
        <LinearGradientContainer
          direction="HORIZONTAL"
          colorArray={[Colors.BASIC_WHITE, Colors.SECONDARY_WHITE]}
          customStyle={themedStyle.content as ViewStyle}>
          <Fragment>
            {sortedMerchants.length > 0 && (
              <LinearGradientContainer
                colorArray={[Colors.BASIC_WHITE, Colors.SECONDARY_WHITE]}
                customStyle={themedStyle.fixOnMobile}>
                <Fragment>
                  {viewPortWidth < 660 && (
                    <Box {...themedStyle.cross}>
                      <Box underlayColor="TRANSPARENT" onPress={onSelected}>
                        <Icon color={'BLACK_21' as ColorOptions} id={'CLOSE'} />
                      </Box>
                    </Box>
                  )}
                  <Box {...styles1(viewPortWidth).cellContainer.enabled}>
                    <Box justifyContent="center" alignSelf="center">
                      <Checkbox
                        type={CheckBoxTypes.ROUNDED}
                        isChecked={true}
                        size={18}
                        color={'GREEN' as ColorOptions}
                      />
                    </Box>
                    <TitleComponent
                      merchantName={merchantname}
                      mid={selectedMid}
                      tid={selectedTid}
                      selectedMerchantStatus={selectedMerchantStatus}
                      breakpoint={viewPortWidth}
                      onCopy={onCopy}
                    />
                  </Box>

                  <ModBox
                    testID={'switchAccount'}
                    underlayColor="TRANSPARENT"
                    onPress={handelSwitchAccount}
                    show={sortedMerchants.length > 1}>
                    <Box {...themedStyle.switch}>
                      <Text color="BLUE" fontSize={12} fontWeight="800">
                        {labelSwitchAccount}
                      </Text>
                      <Icon id={expand ? 'ARROW_UP' : 'ARROW_DOWN'} color={'BLUE' as ColorOptions} />
                    </Box>
                  </ModBox>
                </Fragment>
              </LinearGradientContainer>
            )}

            <MIDSelector onSelected={onSelected} hide={!expand} />
          </Fragment>
        </LinearGradientContainer>
        <SubMenu onSelected={onSelected} hide={expand} />
      </Fragment>
    </LinearGradientContainer>
  )
}

export default UserSettings
